import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MyFundiService } from '../../../services/myFundiService';
import { Router } from '@angular/router';

@Component({
    selector: 'administrator-role',
    templateUrl: './authenticateduser.component.html'
})
export class AuthenticatedUserOveridesComponent {
}

